<div class="page-header-container">
    <div class="page-title">
        {{'faq.title' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <div class="custom-text-input-container search-container flex-grow-1">
        <i class="app-icon icon icon-search icon-xl"></i>
        <kendo-textbox
            type="text"
            [clearButton]='true'
            [placeholder]="'faq.searchPlaceholder' | translate"
            (valueChange)="searchQuery$.next($event)">
        </kendo-textbox>
    </div>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="hasNoData">
    <no-records-placeholder
        [showNoRecordsHeader]="false"
    ></no-records-placeholder>
</div>
   
<faq-list-view *ngIf="(!hasNoData)"
    [frequentlyAskedQuestions]="frequentlyAskedQuestions"
    [props] ="props"
>
</faq-list-view>
